import IframeActivity from "./IframeActivity";

export default function VisibleHabits() {
    return (
        <IframeActivity
            src="/activities/visible-habits/index.html"
            title="Hidden Habits"
        />
    );
}